import IMask from 'imask';
import React, { useState, useEffect, ForwardedRef, Ref } from 'react';
import { IMaskMixin } from 'react-imask';

import StyledInput from './StyledInput';

import { GermanDateTypes } from '$/types/enums/DateTypes';

type TIMaskMixin = {
  mask: string;
  lazy: boolean;
  blocks: { [key: string]: IMask.AnyMaskedOptions };
  iconPosition?: 'end' | 'start';
  name: string;
  inputRef: ForwardedRef<Ref<HTMLInputElement> | undefined>;
  onBlur: (e: React.ChangeEvent<HTMLInputElement>) => void;
  datePickerSelected?: boolean;
  placeholder: string;
};

export const getBlocksFromMask = (
  mask = ''
): { [key: string]: IMask.AnyMaskedOptions } => {
  //TODO - rewrite hardcode function to generate blocks from placeholder
  if (mask === GermanDateTypes.MONTH_YEAR_DOT) {
    return {
      MM: {
        mask: IMask.MaskedRange,
        placeholderChar: 'M',
        from: 0,
        to: 99,
        maxLength: 2,
      },
      JJJJ: {
        mask: IMask.MaskedRange,
        placeholderChar: 'J',
        from: 1000,
        to: 9999,
        maxLength: 4,
      },
    };
  }
  //if (mask === GermanDateTypes.DAY_MONTH_YEAR_DOT )
  else {
    return {
      TT: {
        mask: IMask.MaskedRange,
        placeholderChar: 'T',
        from: 0,
        to: 99,
        maxLength: 2,
      },
      MM: {
        mask: IMask.MaskedRange,
        placeholderChar: 'M',
        from: 0,
        to: 99,
        maxLength: 2,
      },
      JJJJ: {
        mask: IMask.MaskedRange,
        placeholderChar: 'J',
        from: 1000,
        to: 9999,
        maxLength: 4,
      },
    };
  }
};

const MaskedInput = IMaskMixin(
  ({
    inputRef,
    onBlur,
    datePickerSelected,
    ...props
  }: Omit<TIMaskMixin, 'mask' | 'lazy' | 'blocks'>) => {
    const [isPlaceholder, setIsPlaceholder] = useState(true);
    const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
      onBlur(e);
      if (e.target.value === props.placeholder) {
        setIsPlaceholder(true);
      }
    };

    useEffect(() => {
      setIsPlaceholder(!datePickerSelected);
    }, [datePickerSelected]);

    return (
      <StyledInput
        role={'input'}
        onWheel={(e: React.ChangeEvent<HTMLInputElement>) => e.target.blur()}
        ref={inputRef}
        onFocus={() => {
          setIsPlaceholder(false);
        }}
        onBlur={handleBlur}
        isPlaceholder={isPlaceholder}
        {...props}
      />
    );
  }
);

export default MaskedInput as React.FC<TIMaskMixin>;
